import * as Cookies from "es-cookie";
import {
    CustomDetector,
    DetectorOptions,
} from "i18next-browser-languagedetector";

const detector: CustomDetector = {
    name: "ImperoLangDetector",

    lookup(_options: DetectorOptions) {
        // TODO(sc-41808): Move culture lookup into the applications when i18n initialization becomes app-owned.
        const cookie = Cookies.get("org_impero_profile");
        return cookie ? String(JSON.parse(cookie).culture) || "en" : "en";
    },
};

export default detector;
